import { DateRange } from '@rossum/ui/x-date-pickers-pro';
import { shouldBeEndOfDay } from '../../mql/dateUtils';
import { DateOperators } from '../../mql/operators';
import { getCustomFixedDateTime } from './shortcuts';

// see test file for details
export const handleNonRangedDateChange = ({
  selectedDates,
  selectionState,
  dateRange,
  operatorValue,
}: {
  dateRange: DateRange<Date>;
  selectionState?: 'partial' | 'finish' | 'shallow';
  selectedDates: [Date | null, Date | null];
  operatorValue: DateOperators[number]['value'];
}) => {
  const [from, to] = dateRange;

  const targetDate =
    selectionState === 'finish'
      ? selectedDates[0] === from
        ? to
        : from
      : (from ?? to);

  // targetDate should never be null here
  return targetDate
    ? getCustomFixedDateTime(targetDate, shouldBeEndOfDay(operatorValue))
    : null;
};
